import {
	useQuery, 
} from "@tanstack/vue-query";

import { client } from "@/api";

export const useBrokerageList = () => useQuery({
	queryFn: async () => {
		const resp = await client.api.v1.landing.brokerages.get();
		if (resp.status === 200) {
			return resp.data?.brokerages ?? [];
		}
		return [];
	},
	queryKey: ["brokerages"],
	refetchOnMount: false,
});

